<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card>
                        <v-toolbar dense >
                  <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="getPurchases(),menu = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                        <v-spacer/>
                         <v-btn small text color="success"  @click="state='new', form=true"><v-icon left >mdi-plus-box</v-icon> New Purchase</v-btn>
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-3"
                                :headers="headers"
                                :search="search"
                                :items="purchases"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                            <td>
                                              <v-icon  left small color="error" @click="po=item, confirm=true" v-if="item.status == 'on-process'" >mdi-delete</v-icon>
                                            <v-icon small left color="success" @click="$router.push('purchase/view/' + item.id).catch(err => {})">mdi-open-in-new</v-icon> 
                                            {{ item.number }}</td>
                                             <td >
                                                {{ item.company }}
                                            </td>
                                             <td>
                                                {{ item.plate_number }}
                                            </td>
                                            <td>
                                                <v-icon color="info" left small>mdi-file-document-edit-outline</v-icon>  {{ item.created  | moment($date_format) }}
                                            </td>

                                            <td>
                                               <template v-if="item.status!='on-process' && item.returned_date != '0001-01-01T00:00:00Z'">
                                                
                                                 <v-icon color="primary" left small>mdi-truck-delivery</v-icon>  {{ item.returned_date  | moment($date_format) }}
                                               </template>
                                            </td>

                                            <td>
                                                <template v-if="item.status=='delivered'">
                                                 <v-icon color="success" left small>mdi-truck-check</v-icon>  {{ item.delivered_date  | moment($date_format) }}
                                                </template>
                                            </td>
                                             <td :class="STATUS_TEXT(item.status)">
                                               {{ item.status }}
                                            </td>
                                            <td class="text-right">{{ $money(item.paid_amount) }}</td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
    <va-po-form :show="form"  @DialogEvent="formEvent" />
     <va-confirm :show="confirm" cancelbtn="No" okbtn="remove" text="Would you like to remove this item?" @DialogEvent="cEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        menu:false,
        confirm: false,
        state: 'new',
        po: {},
        search:'',
        from_date:'',
        to_date: '',
        date_range:"",
        purchases:[],
        headers: [
              { text: 'P.O #', value: 'number' },
              { text: 'SUPPLIER', value: 'company' },
              { text: 'PLATE NO.', value: 'plate_number'},
              { text: 'P.O. DATE', value: 'created' },
              { text: 'RETURNED', value: 'returned_date' },
              { text: 'DELIVERED', value: 'delivered_date' },
              { text: 'STATUS', value: 'status'},
              { text: 'AMOUNT', value: 'amount', align:'right'}
        ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.SET_MENUS()
          this.GET_SUPPLIERS()
          this.GET_TRUCKS()
           this.GET_DRIVERS()
          var current_date = this.$moment()
          var startdate = current_date.subtract(7, "days")
          this.from_date =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date =  this.$moment().format("YYYY-MM-DD")
          this.getPurchases()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      cEvent(data) {
        this.confirm = false
        if(data != 'cancel') {
            this.removePo()
        }
      },
      formEvent(){
          this.form = false
          this.getPurchases()
      },
      removePo() {
        this.$http.post("purchase/delete", this.po).then(response => {
              this.GET_RESPONSE(response)
              this.getPurchases()
          }).catch(e => {
           console.log(e.data)
         })
      },
      getPurchases: function() {
        this.$http.post("purchase/list",  {from_date:this.from_date, to_date: this.to_date}).then(response => {
              response.data.purchases != null?this.purchases = response.data.purchases:this.purchases=[]
          }).catch(e => {
           console.log(e.data)
         })
     }
     
    }
  }
</script>